import * as types from '../constants/ActionTypes';

export const setPaso = paso => dispatch => {
  dispatch({
    type: types.SET_PASO,
    payload: {
      paso,
    },
  });
};

export const getPaso = () => dispatch => {
  dispatch({
    type: types.GET_PASO,
  });
};

export const reiniciar = () => dispatch => {
  dispatch({
    type: types.REINICIAR,
  });
};

export const setCargaPersonas = cargaPersonasToggle => dispatch => {
  dispatch({
    type: types.SET_CARGA_PERSONAS,
    payload: {
      cargaPersonasToggle,
    },
  });
};

export const setVerPedidoEnvio = verPedidoEnvio => dispatch => {
  dispatch({
    type: types.SET_VER_PEDIDO_ENVIO,
    payload: {
      verPedidoEnvio,
    },
  });
};

export const setVerDepositoContravencion = verDepositoContravencion => dispatch => {
  dispatch({
    type: types.SET_VER_DEPOSITO_CONTRAVENCION,
    payload: {
      verDepositoContravencion,
    },
  });
};

export const setCargaContraventor = cargarContraventorToggle => dispatch => {
  dispatch({
    type: types.SET_CARGA_CONTRAVENTORES,
    payload: {
      cargarContraventorToggle,
    },
  });
};
